import { Spinner } from "react-bootstrap"

export const Loader = ({ show }) => {
    return (
        <>
         {show && (<div className="loader-wrapper">
            <Spinner  animation="border" variant="primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>) }
    </>)
}   